'use client';

import { useCallback, useContext } from 'react';
import DeferredStreamBoundary from '@/common/DeferredStreamBoundary';
import StarRatingOwnerReviewContext from '~/context/vdp/StarRatingOwnerReviewContext';
import type { OwnerReviewsResult } from '~/server-props/vdp/getOwnerReviews';

export default function OwnerReviewsDeferred({
  promise
}: {
  promise: Promise<OwnerReviewsResult | undefined>;
}) {
  const { setInitialReviewsData, triggerFetchOwnerReviews } = useContext(
    StarRatingOwnerReviewContext
  );

  const onResolve = useCallback(
    (data: OwnerReviewsResult | undefined) => {
      if (data) {
        setInitialReviewsData(data.response);
      } else {
        triggerFetchOwnerReviews();
      }
    },
    [setInitialReviewsData, triggerFetchOwnerReviews]
  );

  return (
    <DeferredStreamBoundary
      deferredKey="ownerReviews"
      onResolve={onResolve}
      promise={promise}
    />
  );
}
